module.exports = __webpack_public_path__ + "img/17_101.732ab2e4.png";